<template>
  <div>
    <hero-cards :cards="mainCategory['hero_cards']"></hero-cards>

    <BenefitsBar />

    <section class="itb-references-alike-set" v-if="realizations.length">
      <h2>{{ $t("main_category.our_realizations") }}</h2>
      <p class="itb-h2-subtitle">
        {{ $t("main_category.we_are_proud") }}
      </p>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4" v-for="realization in realizations">
            <router-link
              class="text-decoration-none"
              :to="{
                name: 'realizationDetail',
                params: {
                  categoryAlias: mainCategory.alias,
                  realizationAlias: realization.id + '-' + realization.alias,
                },
              }"
            >
              <div
                class="card w-100 itb-lazy-loading-bg"
                v-lazy:background-image="
                  realization.image ? '/uploads/' + realization.image : null
                "
              >
                <div class="card-body d-flex p-0">
                  <div class="itb-text align-self-end w-100">
                    <h3 class="mb-0">
                      {{ realization.name + ", " + realization.location }}
                    </h3>
                    <p class="itb-h3-subtitle">
                      {{ $t("constants." + mainCategory.name) }}
                    </p>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <router-link
        :to="{
          name: 'realizationsByCategory',
          params: {
            categoryAlias: mainCategory.alias,
          },
        }"
        class="btn btn-primary itb-btn-icon"
      >
        {{ $t("main_category.show_all_realizations") }}
        <img
          src="/images/icons/4soft_icon_angle-right.svg"
          :alt="
            $t('general.button') +
            ' ' +
            $t('main_category.show_all_realizations')
          "
          class="itb-icon itb-angle-right-icon"
        />
      </router-link>
    </section>

    <section class="itb-references-alike-set" v-if="playgrounds.length">
      <h2>{{ $t("main_category.playgrounds_offer") }}</h2>
      <p
        class="itb-h2-subtitle"
        v-html="$t('main_category.choose_out_of_our_offfer')"
      ></p>
      <div class="container">
        <div class="row">
          <div class="col-12 col-md-4" v-for="playground in playgrounds">
            <router-link
              class="text-decoration-none"
              :to="{
                name: 'playgroundDetail',
                params: {
                  playgroundAlias: playground.id + '-' + playground.alias,
                },
              }"
            >
              <div
                class="card w-100 itb-with-border itb-lazy-loading-bg"
                v-lazy:background-image="
                  playground.imageHero
                    ? '/uploads/' +
                      playground.imageHero.path +
                      '/sm_' +
                      playground.imageHero.name
                    : null
                "
              >
                <div class="card-body d-flex p-0">
                  <div class="itb-text align-self-end w-100">
                    <h3 class="mb-0">
                      {{ playground.title }}
                    </h3>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <router-link
        :to="{ name: 'playgrounds' }"
        class="btn btn-primary itb-btn-icon"
      >
        {{ $t("main_category.browse_all_playgrounds") }}
        <img
          src="/images/icons/4soft_icon_angle-right.svg"
          :alt="
            $t('general.button') +
            ' ' +
            $t('main_category.browse_all_playgrounds')
          "
          class="itb-icon itb-angle-right-icon"
        />
      </router-link>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BenefitsBar from "../components/BenefitsBar";

export default {
  data() {
    return {
      mainCategory: [],
      realizations: [],
      playgrounds: [],
    };
  },

  components: {
    BenefitsBar,
  },

  mounted() {
    axios
      .get(`/getMainCategoryPage/${this.$route.name.split("-")[1]}`)
      .then((response) => {
        this.pageParams = response.data.params;
        this.mainCategory = response.data.mainCategory;
        this.realizations = response.data.realizations;
        this.playgrounds = response.data.playgrounds;

        this.pageParams.page_title = this.$t(
          "constants." + this.pageParams.page_title
        );

        this.pageParams.page_subtitle = this.$t(
          "constants." + this.pageParams.page_subtitle
        );

        this.setPageParams(this.pageParams);
      })
      .catch((error) => {
        console.log(error);
      });
  },

  computed: {
    ...mapGetters({
      appParams: "getAppParams",
    }),
  },

  methods: {
    ...mapActions(["setPageParams"]),
    scrollToElement(elementId) {
      this.$parent.scrollToElement(elementId);
    },
  },
};
</script>
